import { useSystemMessages } from 'api/systemMessage/systemMessage.api'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { Module } from 'types/modules'
import RedirectSnackbar from 'ui/molecules/RedirectSnackbar/RedirectSnackbar'

export default function SystemMessageBanner({ module }: { module: Module }): ReactElement {
  const systemMessages = useSystemMessages()

  return (
    <>
      {systemMessages.data
        ?.filter((message) => {
          const now = moment()
          const hasStarted = !message.start_time || moment(message.start_time).isBefore(now)
          const hasEnded = message.end_time && moment(message.end_time).isSameOrBefore(now)
          return hasStarted && !hasEnded && message.modules.includes(module)
        })
        .map((message) => (
          <RedirectSnackbar
            key={message.id}
            text={message.text}
            style={message.severity}
            systemId={message.id}
            name={`{message.title}-${message.id}`}
          />
        ))}
    </>
  )
}
